import MultiLineString from 'ol/geom/MultiLineString';
import { INTERSECTION_TYPE } from '../constants';
import { getIntersectionType } from './getLinesIntersection';
import { getIntersectionSegmentIndex } from './getIntersectionCoord';
import { getIntersectionSegmentIndexByDistance } from './getIntersectionSegmentIndexByDistance';
import { splitMultiLineStringInPoint } from './splitMultiLineStringInPoint';
export const getLengthMultiLineString = (multiLineString) => {
    let length = 0;
    multiLineString.forEach((lineString) => {
        const lineStringLength = lineString.length;
        for (let lineStringSegmentIndex = 0; lineStringSegmentIndex < lineStringLength - 1; lineStringSegmentIndex++) {
            const startPoint = lineString[lineStringSegmentIndex];
            const endPoint = lineString[lineStringSegmentIndex + 1];
            const a = startPoint[0] - endPoint[0];
            const b = startPoint[1] - endPoint[1];
            length += Math.sqrt(a * a + b * b);
        }
    });
    return length;
};
export const modifyMultiLineString = (multiLineString, intersectionCoord, selectCoord) => {
    let selectedSegment;
    if (selectCoord) {
        selectedSegment = getIntersectionSegmentIndex(selectCoord, multiLineString);
        if (selectedSegment.lineStringIndex === null ||
            selectedSegment.lineStringSegmentIndex === null) {
            return multiLineString;
        }
    }
    else {
        selectedSegment = getIntersectionSegmentIndexByDistance(multiLineString, intersectionCoord);
        if (selectedSegment.lineStringIndex === null ||
            selectedSegment.lineStringSegmentIndex === null) {
            return multiLineString;
        }
    }
    const lineString = multiLineString[selectedSegment.lineStringIndex];
    const segment = [
        lineString[selectedSegment.lineStringSegmentIndex],
        lineString[selectedSegment.lineStringSegmentIndex + 1],
    ];
    const type = getIntersectionType(segment, intersectionCoord);
    let splittedLineString;
    switch (type) {
        case INTERSECTION_TYPE.CROP: {
            const splittedMultiLineStrings = splitMultiLineStringInPoint(intersectionCoord, [lineString]);
            if (selectCoord) {
                let distanceSquare = Infinity;
                for (const splittedMultiLineString of splittedMultiLineStrings) {
                    const mls = new MultiLineString(splittedMultiLineString);
                    const closestPoint = mls.getClosestPoint(selectCoord);
                    const dx = closestPoint[0] - selectCoord[0];
                    const dy = closestPoint[1] - selectCoord[1];
                    const currentDistanceSquare = dx * dx + dy * dy;
                    if (currentDistanceSquare < distanceSquare) {
                        distanceSquare = currentDistanceSquare;
                        splittedLineString = splittedMultiLineString[0];
                    }
                }
            }
            else {
                let distance = 0;
                for (const splittedMultiLineString of splittedMultiLineStrings) {
                    const currentDistance = getLengthMultiLineString(splittedMultiLineString);
                    if (currentDistance > distance) {
                        distance = currentDistance;
                        splittedLineString = splittedMultiLineString[0];
                    }
                }
            }
            break;
        }
        case INTERSECTION_TYPE.REPLACE: {
            splittedLineString = lineString.slice(0, selectedSegment.lineStringSegmentIndex + 1);
            splittedLineString.push(intersectionCoord);
            break;
            // nasledujici segmenty pryc a novy bod misto nich na konec
        }
        case INTERSECTION_TYPE.EXTEND: {
            splittedLineString = lineString.slice(selectedSegment.lineStringSegmentIndex + 1);
            splittedLineString.unshift(intersectionCoord);
            break;
            // predchazejici segmenty pryc a novy bod misto nich na zacatek
        }
    }
    const result = [...multiLineString];
    if (splittedLineString) {
        result[selectedSegment.lineStringIndex] = splittedLineString;
    }
    return result;
};
//# sourceMappingURL=modifyLineString.js.map